/* eslint-disable import/prefer-default-export */
import { isProd } from 'Utils/env/env';
import { useEffect } from 'react';

export const DEVTOOLS_QUERY_KEY = 'devtools';
export const DEVTOOLS_STORAGE_KEY = 'DEVTOOLS';

export default function useDevToolsQueryWatcher() {
  useEffect(() => {
    if (!isProd()) {
      const query = new URLSearchParams(window.location.search);
      const devToolsQueryParam = query.get(DEVTOOLS_QUERY_KEY);
      if (!devToolsQueryParam) return;

      query.delete(DEVTOOLS_QUERY_KEY);
      if (devToolsQueryParam === 'true') {
        localStorage.setItem(DEVTOOLS_STORAGE_KEY, 'true');
      } else if (devToolsQueryParam === 'false') {
        localStorage.removeItem(DEVTOOLS_STORAGE_KEY);
      }
      window.location.assign(`${window.location.pathname}?${query}`);
    }
  }, []);
}
